module.exports = __webpack_public_path__ + "img/cap1_qubit_resonator.98f1cdb1.svg";